import { Link2 } from "lucide-react";
import { STATUS_LABEL } from "@/lib/constants";
import { fmtDate } from "@/lib/time";
import { cn } from "@/lib/utils";

const when = (x) => String(x.intervention_date || x.scheduled_date || x.created_at || "").slice(0, 10);
const whenNote = (x) => (x.intervention_date ? "" : x.scheduled_date ? " (appuntamento cliente)" : x.created_at ? " (apertura)" : "");
const daysBetween = (a, b) => (a && b ? Math.round((new Date(b) - new Date(a)) / 86400000) : null);

export const RelatedTimeline = ({ current, related, onOpen }) => {
  const items = [{ ...current, matched: [], _current: true }, ...related.filter((r) => r.id !== current.id)].sort((a, b) => when(a).localeCompare(when(b)) || String(a.created_at || "").localeCompare(String(b.created_at || "")) || String(a.code).localeCompare(String(b.code)));
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-4" data-testid="related-tickets">
      <div className="mb-1 flex items-center gap-2"><Link2 size={16} className="text-amber-600" /><h3 className="text-sm font-bold text-amber-800">Ticket collegati ({items.length - 1})</h3></div>
      <p className="mb-3 text-xs text-amber-700">Successione per data intervento (o appuntamento cliente) dei ticket con lo stesso ID OLO, ID Risorsa o Cliente. Clicca per aprirli.</p>
      <div className="overflow-x-auto pb-1" data-testid="related-timeline">
        <ol className="relative flex w-max gap-4 px-1 pt-1">
          <span className="pointer-events-none absolute left-6 right-[12.9rem] top-[11px] h-0.5 bg-amber-300" aria-hidden />
          {items.map((d, i) => {
            const gap = i > 0 ? daysBetween(when(items[i - 1]), when(d)) : null;
            return (
            <li key={d.id} className="relative flex w-56 shrink-0 flex-col" data-testid={d._current ? "related-current" : `related-item-${d.code}`}>
              {gap !== null && (
                <span className="absolute left-[-6.125rem] top-[2px] z-10 -translate-x-1/2 whitespace-nowrap rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[10px] font-bold text-amber-800" data-testid={`related-gap-${d.code}`}>
                  {gap === 0 ? "stesso giorno" : `${gap} ${gap === 1 ? "giorno" : "giorni"}`}
                </span>
              )}
              <span className={cn("relative z-10 mb-1 ml-3 h-5 w-5 rounded-full border-2",
                d._current ? "border-primary bg-primary ring-4 ring-primary/20" : "border-amber-400 bg-white")} />
              <p className={cn("mb-1 ml-1 text-[11px] font-semibold", d._current ? "text-primary" : "text-amber-800")}>
                {when(d) ? `${fmtDate(when(d))}${whenNote(d)}` : "Senza data"}
              </p>
              <button type="button" disabled={d._current} onClick={() => onOpen(d.id)}
                className={cn("flex-1 rounded-lg border p-3 text-left transition-colors",
                  d._current ? "cursor-default border-2 border-primary bg-white shadow-md" : "border-amber-200 bg-white hover:border-primary hover:bg-accent")}>
                <p className="font-mono text-xs font-bold text-primary">{d.code} · {STATUS_LABEL[d.status] || d.status}</p>
                <p className="truncate text-sm font-semibold text-navy">{d.client_name || "—"}</p>
                <p className="truncate text-xs text-muted-foreground">{d.category || "—"}</p>
                {d._current ? (
                  <span className="mt-2 inline-block max-w-full truncate rounded-full border border-primary/30 bg-primary/10 px-2 py-0.5 text-[10px] font-bold text-primary">{d.id_olo ? `ID OLO ${d.id_olo}` : "ID OLO —"}</span>
                ) : (
                  <span className="mt-2 inline-block rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[10px] font-bold text-amber-700">{d.matched.join(", ")}</span>
                )}
              </button>
            </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
};
